import {InjectionToken} from '@angular/core';

/**
 * Default values for BlocksConfig are all false.
 * You only need to set values that have to be true without touching the others,
 * as they will be automatically set to false
 */
export class BlocksConfig {
  /**
   * toggles apetrack
   */
  tracking: boolean;

  /**
   * makes blocks fillable
   */
  submittable: boolean;

  /**
   * blocks can be manipulated (Drag & Drop, Update, Delete etc.)
   */
  editable: boolean;

  /**
   * allows uploading (e.g. image block, attachment block)
   */
  uploadable: boolean;

  /**
   * toggles running complex operations, e.g. iban validation
   */
  validation: boolean;

  /**
   * excluded blocks (i.e. visible=false) will be hidden if this is true
   */
  excludable: boolean;

  /**
   * makes a block selectable / toggle click listeners
   */
  selectable: boolean;

  /**
   * interactive elements are activated if true (buttons, overlays etc.)
   */
  interactive: boolean;

  /**
   * tokens can be modified
   */
  tokensEditable: boolean;
  preview: boolean;

  /**
   * The suffix that gets added to the html-id
   */
  idSuffix: string;

  /**
   * Determines if the required-indicator is shown.
   */
  showRequiredIndicator: boolean;

  /**
   * Activate or deactivate the participant-based coloring of the input blocks.
   */
  participantColoring: boolean;

  localizable: boolean;

  /**
   * Activate or deactivate the rules engine and all of its side-effects.
   */
  calculatable: boolean;

  /**
   * Shows signature inputs as a black line with Text "Date, Place, Signature"
   * Hides placeholders and other non-essential elements to improve readability in print mode
   */
  printOptimized: boolean;

  constructor(v: Partial<BlocksConfig> = {}) {
    this.tracking = v.tracking ?? false;
    this.submittable = v.submittable ?? false;
    this.editable = v.editable ?? false;
    this.uploadable = v.uploadable ?? false;
    this.validation = v.validation ?? false;
    this.excludable = v.excludable ?? false;
    this.selectable = v.selectable ?? false;
    this.interactive = v.interactive ?? false;
    this.tokensEditable = v.tokensEditable ?? false;
    this.preview = v.preview ?? false;
    this.idSuffix = v.idSuffix ?? '';
    this.showRequiredIndicator = v.showRequiredIndicator ?? true;
    this.participantColoring = v.participantColoring ?? false;
    this.localizable =v.preview ?? true;
    this.calculatable = v.calculatable ?? false;
    this.printOptimized = v.printOptimized ?? false;
  }
}

export const BLOCKS_CONFIG: InjectionToken<BlocksConfig> = new InjectionToken<BlocksConfig>('blocks_config');
